import type { TabType } from './types';

export const HEADER_CONFIG = {
  HEIGHT: '53px',
  BG_COLOR: 'white',
  NAVIGATION_HEIGHT: '32px',
} as const;

export const COLORS = {
  ACTIVE_BG: '#6B5FC6',
  ACTIVE_HOVER: '#6347CC',
  ACTIVE_PRESSED: '#5639B5',
  INACTIVE_TEXT: 'gray.700',
  ACTIVE_TEXT: '#FFFFFF',
} as const;

export const MENU_ITEMS = {
  blocks: ['All Blocks', 'Financial Blocks', 'Custom Blocks'],
  dimensions: ['Time Dimensions', 'Product Dimensions', 'Location Dimensions'],
  import: ['Import CSV', 'Import Excel', 'Connect Database'],
} as const;

export const BUTTON_STYLES = {
  fontWeight: 900,
  fontSize: '16px',
  lineHeight: '100%',
  letterSpacing: '0%',
  textAlign: 'center' as const,
  // borderRadius: '12px',
  width: 'auto',
} as const;

export const MODEL_TAB_CONFIG: ReadonlyArray<{
  key: string;
  name: string;
  urlValue: string;
  tabType: TabType;
}> = [
  { key: 'dashboard', name: 'Dashboard', urlValue: 'dashboard', tabType: 'dashboard' },
  { key: 'blocks', name: 'Blocks', urlValue: 'blocks', tabType: 'blocks' },
  { key: 'dimensions', name: 'Dimensions', urlValue: 'dimensions', tabType: 'dimensions' },
  { key: 'data', name: 'Data', urlValue: 'data', tabType: 'import' },
] as const;

export const DEFAULT_MODEL_TAB_URL = 'dashboard';

export const getTabFromUrlValue = (urlValue: string | null): TabType | null => {
  if (!urlValue) {
    return null;
  }

  const tabConfiguration = MODEL_TAB_CONFIG.find((tab) => tab.urlValue === urlValue);
  return tabConfiguration?.tabType ?? null;
};

export const getUrlValueFromTab = (tabType: TabType): string => {
  const tabConfiguration = MODEL_TAB_CONFIG.find((tab) => tab.tabType === tabType);
  return tabConfiguration?.urlValue ?? DEFAULT_MODEL_TAB_URL;
};
